import { produce } from "immer";
import * as Actions from "pages/Logs/store/logsActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [] };
const logsReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_LOGS_SUCCESS: {
      const payload = action.payload;
      const logs = payload.logs;
      const logIds = payload.logs.map(log => log.id);
      const byId = logs.reduce((obj, log) => {
        obj[log.id] = log;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      draft.allIds = logIds;
      break;
    }
    default:
      return draft;
  }
}, initialState);

export default logsReducer;
